import React from 'react';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import PadlockEngaged from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PadlockEngaged';
import PaperMoneyStack from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PaperMoneyStack';
import PottedPlantWithDollarSignCircle from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PottedPlantWithDollarSignCircle';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';
// styles
import { ColStyled } from './styles';

export const ITEMS = [
  {
    id: 'whole-life-insurance-payout',
    icon: PaperMoneyStack,
    title: 'Guaranteed payout',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Along with feeling confident that your loved ones will get a guaranteed death benefit<sup>1</sup> when you&#39;re no longer here, you&#39;ll have lifelong coverage.
      </Typography>
    ),
  },
  {
    id: 'whole-life-insurance-never-increase',
    icon: PadlockEngaged,
    title: 'Costs are set',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        How much you&#39;ll pay will depend on things like your coverage amount, age, and health. Once your premiums are set, what you pay each month (or yearly) will never go up.<sup>5</sup>
      </Typography>
    ),
  },
  {
    id: 'whole-life-insurance-cash-value',
    icon: PottedPlantWithDollarSignCircle,
    title: 'Accumulates cash value',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Your policy accumulates a pool of money (aka cash value) over time.<sup>2</sup> You can use it for anything you need&#8212;unexpected expenses, college tuition, or as income when you retire.
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='whole-life-insurance'
      backgroundVariant='lightB'
      headingText={
        <>
          Your whole life insurance <WidowBlock>policy highlights</WidowBlock>
        </>
      }
      cardDataArray={ITEMS}
      secondaryContent={
        <Row align='center'>
          <ColStyled>
            <Link
              id='whole-life-insurance-product-cta'
              variant='buttonLinkPrimary'
              themeType='lightTheme'
              linkUrl='/find-a-financial-advisor/'
              ariaLabel='Get started with a financial advisor'>
              Get Started
            </Link>
          </ColStyled>
        </Row>
      }
    />
  );
};
